import type { SVGProps } from 'react'

export const Conditions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="80"
    viewBox="0 0 81 80"
    width="81"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M18.0842 70C16.0058 70 14.2222 69.2619 12.7333 67.7858C11.2444 66.3097 10.5 64.5172 10.5 62.4083C10.5 60.5333 11.0931 58.9025 12.2792 57.5158C13.4647 56.1286 14.9444 55.2622 16.7183 54.9167V46.385C16.7183 44.3206 17.48 42.5267 19.0033 41.0033C20.5267 39.48 22.3206 38.7183 24.385 38.7183H39.2183V25.1667C37.4317 24.825 35.9283 23.9531 34.7083 22.5508C33.4883 21.1486 32.8783 19.5056 32.8783 17.6217C32.8783 15.5044 33.62 13.705 35.1033 12.2233C36.5867 10.7411 38.3633 10 40.4333 10C42.5678 10 44.3828 10.7411 45.8783 12.2233C47.3739 13.705 48.1217 15.5044 48.1217 17.6217C48.1217 19.5056 47.5117 21.1486 46.2917 22.5508C45.0717 23.9531 43.5683 24.825 41.7817 25.1667V38.7183H56.615C58.6794 38.7183 60.4733 39.48 61.9967 41.0033C63.52 42.5267 64.2817 44.3206 64.2817 46.385V54.9167C66.0556 55.2639 67.5353 56.1336 68.7208 57.5258C69.907 58.9175 70.5 60.545 70.5 62.4083C70.5 64.5017 69.7475 66.2903 68.2425 67.7742C66.7375 69.2581 64.9369 70 62.8408 70C60.7625 70 58.9789 69.2589 57.49 67.7767C56.0011 66.295 55.2567 64.4956 55.2567 62.3783C55.2567 60.455 55.8836 58.785 57.1375 57.3683C58.392 55.9517 59.9189 55.1003 61.7183 54.8142V46.385C61.7183 44.9406 61.2289 43.7289 60.25 42.75C59.2711 41.7711 58.0594 41.2817 56.615 41.2817H41.7817H39.2183H24.385C22.9406 41.2817 21.7289 41.7711 20.75 42.75C19.7711 43.7289 19.2817 44.9406 19.2817 46.385V54.8142C21.0811 55.1003 22.6081 55.9517 23.8625 57.3683C25.1164 58.785 25.7433 60.455 25.7433 62.3783C25.7433 64.4956 24.9908 66.295 23.4858 67.7767C21.9808 69.2589 20.1803 70 18.0842 70Z"
      fill="url(#paint0_linear_2794_24130)"
      fillRule="evenodd"
    />
    <foreignObject height="51" width="51" x="-7.5" y="37">
      <div
        style={{
          backdropFilter: 'blur(4px)',
          clipPath: 'url(#bgblur_0_2794_24130_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="8">
      <mask fill="white" id="path-2-inside-1_2794_24130">
        <path d="M0.5 53C0.5 48.5817 4.08172 45 8.5 45H27.5C31.9183 45 35.5 48.5817 35.5 53V72C35.5 76.4183 31.9183 80 27.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V53Z" />
      </mask>
      <path
        d="M0.5 53C0.5 48.5817 4.08172 45 8.5 45H27.5C31.9183 45 35.5 48.5817 35.5 53V72C35.5 76.4183 31.9183 80 27.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V53Z"
        fill="url(#paint1_linear_2794_24130)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint2_angular_2794_24130_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-2-inside-1_2794_24130)"
      >
        <g transform="matrix(2.40889e-10 0.0175 -0.0175 2.80941e-09 18 62.5)">
          <foreignObject
            height="2057.14"
            width="2057.14"
            x="-1028.57"
            y="-1028.57"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M8.5 45V45.5H27.5V45V44.5H8.5V45ZM35.5 53H35V72H35.5H36V53H35.5ZM27.5 80V79.5H8.5V80V80.5H27.5V80ZM0.5 72H1V53H0.5H0V72H0.5ZM8.5 80V79.5C4.35786 79.5 1 76.1421 1 72H0.5H0C0 76.6944 3.80558 80.5 8.5 80.5V80ZM35.5 72H35C35 76.1421 31.6421 79.5 27.5 79.5V80V80.5C32.1944 80.5 36 76.6944 36 72H35.5ZM27.5 45V45.5C31.6421 45.5 35 48.8578 35 53H35.5H36C36 48.3056 32.1944 44.5 27.5 44.5V45ZM8.5 45V44.5C3.80558 44.5 0 48.3056 0 53H0.5H1C1 48.8578 4.35786 45.5 8.5 45.5V45Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:4.8177861344811390e-07,&#34;m01&#34;:-35.000007629394531,&#34;m02&#34;:35.500003814697266,&#34;m10&#34;:35.000003814697266,&#34;m11&#34;:5.6188200687756762e-06,&#34;m12&#34;:44.999980926513672},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-2-inside-1_2794_24130)"
      />
    </g>
    <path
      d="M19.5 50.5C17.8431 50.5 16.5 51.8431 16.5 53.5C16.5 55.1568 17.8431 56.5 19.5 56.5H26.5C28.1569 56.5 29.5 55.1568 29.5 53.5C29.5 51.8431 28.1569 50.5 26.5 50.5H19.5ZM9.5 50.5C7.84315 50.5 6.5 51.8431 6.5 53.5C6.5 55.1568 7.84315 56.5 9.5 56.5C11.1569 56.5 12.5 55.1568 12.5 53.5C12.5 51.8431 11.1569 50.5 9.5 50.5Z"
      fill="url(#paint3_linear_2794_24130)"
      opacity="0.9"
    />
    <path
      d="M9.5 59.5C7.84315 59.5 6.5 60.8431 6.5 62.5C6.5 64.1568 7.84315 65.5 9.5 65.5H26.5C28.1569 65.5 29.5 64.1568 29.5 62.5C29.5 60.8431 28.1569 59.5 26.5 59.5H9.5Z"
      fill="url(#paint4_linear_2794_24130)"
      opacity="0.9"
    />
    <path
      d="M9.5 68.5C7.84315 68.5 6.5 69.8431 6.5 71.5C6.5 73.1568 7.84315 74.5 9.5 74.5H26.5C28.1569 74.5 29.5 73.1568 29.5 71.5C29.5 69.8431 28.1569 68.5 26.5 68.5H9.5Z"
      fill="url(#paint5_linear_2794_24130)"
      opacity="0.9"
    />
    <foreignObject height="51" width="51" x="37.5" y="37">
      <div
        style={{
          backdropFilter: 'blur(4px)',
          clipPath: 'url(#bgblur_1_2794_24130_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="8">
      <mask fill="white" id="path-7-inside-2_2794_24130">
        <path d="M45.5 53C45.5 48.5817 49.0817 45 53.5 45H72.5C76.9183 45 80.5 48.5817 80.5 53V72C80.5 76.4183 76.9183 80 72.5 80H53.5C49.0817 80 45.5 76.4183 45.5 72V53Z" />
      </mask>
      <path
        d="M45.5 53C45.5 48.5817 49.0817 45 53.5 45H72.5C76.9183 45 80.5 48.5817 80.5 53V72C80.5 76.4183 76.9183 80 72.5 80H53.5C49.0817 80 45.5 76.4183 45.5 72V53Z"
        fill="url(#paint6_linear_2794_24130)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint7_angular_2794_24130_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-7-inside-2_2794_24130)"
      >
        <g transform="matrix(2.40889e-10 0.0175 -0.0175 2.80941e-09 63 62.5)">
          <foreignObject
            height="2057.14"
            width="2057.14"
            x="-1028.57"
            y="-1028.57"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M53.5 45V45.5H72.5V45V44.5H53.5V45ZM80.5 53H80V72H80.5H81V53H80.5ZM72.5 80V79.5H53.5V80V80.5H72.5V80ZM45.5 72H46V53H45.5H45V72H45.5ZM53.5 80V79.5C49.3579 79.5 46 76.1422 46 72H45.5H45C45 76.6944 48.8056 80.5 53.5 80.5V80ZM80.5 72H80C80 76.1422 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM72.5 45V45.5C76.6421 45.5 80 48.8579 80 53H80.5H81C81 48.3056 77.1944 44.5 72.5 44.5V45ZM53.5 45V44.5C48.8056 44.5 45 48.3056 45 53H45.5H46C46 48.8579 49.3579 45.5 53.5 45.5V45Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:4.8177861344811390e-07,&#34;m01&#34;:-35.000007629394531,&#34;m02&#34;:80.50,&#34;m10&#34;:35.000003814697266,&#34;m11&#34;:5.6188200687756762e-06,&#34;m12&#34;:45.000011444091797},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-7-inside-2_2794_24130)"
      />
    </g>
    <path
      d="M64.5 50.5C62.8431 50.5 61.5 51.8432 61.5 53.5C61.5 55.1569 62.8431 56.5 64.5 56.5H71.5C73.1569 56.5 74.5 55.1569 74.5 53.5C74.5 51.8432 73.1569 50.5 71.5 50.5H64.5ZM54.5 50.5C52.8431 50.5 51.5 51.8432 51.5 53.5C51.5 55.1569 52.8431 56.5 54.5 56.5C56.1569 56.5 57.5 55.1569 57.5 53.5C57.5 51.8432 56.1569 50.5 54.5 50.5Z"
      fill="url(#paint8_linear_2794_24130)"
      opacity="0.9"
    />
    <path
      d="M54.5 59.5C52.8431 59.5 51.5 60.8432 51.5 62.5C51.5 64.1569 52.8431 65.5 54.5 65.5H71.5C73.1569 65.5 74.5 64.1569 74.5 62.5C74.5 60.8432 73.1569 59.5 71.5 59.5H54.5Z"
      fill="url(#paint9_linear_2794_24130)"
      opacity="0.9"
    />
    <path
      d="M54.5 68.5C52.8431 68.5 51.5 69.8432 51.5 71.5C51.5 73.1569 52.8431 74.5 54.5 74.5H71.5C73.1569 74.5 74.5 73.1569 74.5 71.5C74.5 69.8432 73.1569 68.5 71.5 68.5H54.5Z"
      fill="url(#paint10_linear_2794_24130)"
      opacity="0.9"
    />
    <foreignObject height="51" width="51" x="15" y="-8.00002">
      <div
        style={{
          backdropFilter: 'blur(4px)',
          clipPath: 'url(#bgblur_2_2794_24130_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="8">
      <mask fill="white" id="path-12-inside-3_2794_24130">
        <path d="M23 7.99998C23 3.58171 26.5817 -1.52588e-05 31 -1.52588e-05H50C54.4183 -1.52588e-05 58 3.58171 58 7.99998V27C58 31.4183 54.4183 35 50 35H31C26.5817 35 23 31.4183 23 27V7.99998Z" />
      </mask>
      <path
        d="M23 7.99998C23 3.58171 26.5817 -1.52588e-05 31 -1.52588e-05H50C54.4183 -1.52588e-05 58 3.58171 58 7.99998V27C58 31.4183 54.4183 35 50 35H31C26.5817 35 23 31.4183 23 27V7.99998Z"
        fill="url(#paint11_linear_2794_24130)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint12_angular_2794_24130_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-12-inside-3_2794_24130)"
      >
        <g transform="matrix(2.40889e-10 0.0175 -0.0175 2.80941e-09 40.5 17.5)">
          <foreignObject
            height="2057.14"
            width="2057.14"
            x="-1028.57"
            y="-1028.57"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M31 -1.52588e-05V0.499985H50V-1.52588e-05V-0.500015H31V-1.52588e-05ZM58 7.99998H57.5V27H58H58.5V7.99998H58ZM50 35V34.5H31V35V35.5H50V35ZM23 27H23.5V7.99998H23H22.5V27H23ZM31 35V34.5C26.8579 34.5 23.5 31.1421 23.5 27H23H22.5C22.5 31.6944 26.3056 35.5 31 35.5V35ZM58 27H57.5C57.5 31.1421 54.1421 34.5 50 34.5V35V35.5C54.6944 35.5 58.5 31.6944 58.5 27H58ZM50 -1.52588e-05V0.499985C54.1421 0.499985 57.5 3.85785 57.5 7.99998H58H58.5C58.5 3.30556 54.6944 -0.500015 50 -0.500015V-1.52588e-05ZM31 -1.52588e-05V-0.500015C26.3056 -0.500015 22.5 3.30556 22.5 7.99998H23H23.5C23.5 3.85785 26.8579 0.499985 31 0.499985V-1.52588e-05Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:4.8177861344811390e-07,&#34;m01&#34;:-35.000007629394531,&#34;m02&#34;:58.000003814697266,&#34;m10&#34;:35.000003814697266,&#34;m11&#34;:5.6188200687756762e-06,&#34;m12&#34;:-2.0154360754531808e-05},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-12-inside-3_2794_24130)"
      />
    </g>
    <path
      d="M42 5.49998C40.3431 5.49998 39 6.84313 39 8.49998C39 10.1568 40.3431 11.5 42 11.5H49C50.6569 11.5 52 10.1568 52 8.49998C52 6.84313 50.6569 5.49998 49 5.49998H42ZM32 5.49998C30.3431 5.49998 29 6.84313 29 8.49998C29 10.1568 30.3431 11.5 32 11.5C33.6569 11.5 35 10.1568 35 8.49998C35 6.84313 33.6569 5.49998 32 5.49998Z"
      fill="url(#paint13_linear_2794_24130)"
      opacity="0.9"
    />
    <path
      d="M32 14.5C30.3431 14.5 29 15.8431 29 17.5C29 19.1568 30.3431 20.5 32 20.5H49C50.6569 20.5 52 19.1568 52 17.5C52 15.8431 50.6569 14.5 49 14.5H32Z"
      fill="url(#paint14_linear_2794_24130)"
      opacity="0.9"
    />
    <path
      d="M32 23.5C30.3431 23.5 29 24.8431 29 26.5C29 28.1568 30.3431 29.5 32 29.5H49C50.6569 29.5 52 28.1568 52 26.5C52 24.8431 50.6569 23.5 49 23.5H32Z"
      fill="url(#paint15_linear_2794_24130)"
      opacity="0.9"
    />
    <defs>
      <clipPath
        id="bgblur_0_2794_24130_clip_path"
        transform="translate(7.5 -37)"
      >
        <path d="M0.5 53C0.5 48.5817 4.08172 45 8.5 45H27.5C31.9183 45 35.5 48.5817 35.5 53V72C35.5 76.4183 31.9183 80 27.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V53Z" />
      </clipPath>
      <clipPath id="paint2_angular_2794_24130_clip_path">
        <path
          d="M8.5 45V45.5H27.5V45V44.5H8.5V45ZM35.5 53H35V72H35.5H36V53H35.5ZM27.5 80V79.5H8.5V80V80.5H27.5V80ZM0.5 72H1V53H0.5H0V72H0.5ZM8.5 80V79.5C4.35786 79.5 1 76.1421 1 72H0.5H0C0 76.6944 3.80558 80.5 8.5 80.5V80ZM35.5 72H35C35 76.1421 31.6421 79.5 27.5 79.5V80V80.5C32.1944 80.5 36 76.6944 36 72H35.5ZM27.5 45V45.5C31.6421 45.5 35 48.8578 35 53H35.5H36C36 48.3056 32.1944 44.5 27.5 44.5V45ZM8.5 45V44.5C3.80558 44.5 0 48.3056 0 53H0.5H1C1 48.8578 4.35786 45.5 8.5 45.5V45Z"
          mask="url(#path-2-inside-1_2794_24130)"
        />
      </clipPath>
      <clipPath
        id="bgblur_1_2794_24130_clip_path"
        transform="translate(-37.5 -37)"
      >
        <path d="M45.5 53C45.5 48.5817 49.0817 45 53.5 45H72.5C76.9183 45 80.5 48.5817 80.5 53V72C80.5 76.4183 76.9183 80 72.5 80H53.5C49.0817 80 45.5 76.4183 45.5 72V53Z" />
      </clipPath>
      <clipPath id="paint7_angular_2794_24130_clip_path">
        <path
          d="M53.5 45V45.5H72.5V45V44.5H53.5V45ZM80.5 53H80V72H80.5H81V53H80.5ZM72.5 80V79.5H53.5V80V80.5H72.5V80ZM45.5 72H46V53H45.5H45V72H45.5ZM53.5 80V79.5C49.3579 79.5 46 76.1422 46 72H45.5H45C45 76.6944 48.8056 80.5 53.5 80.5V80ZM80.5 72H80C80 76.1422 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM72.5 45V45.5C76.6421 45.5 80 48.8579 80 53H80.5H81C81 48.3056 77.1944 44.5 72.5 44.5V45ZM53.5 45V44.5C48.8056 44.5 45 48.3056 45 53H45.5H46C46 48.8579 49.3579 45.5 53.5 45.5V45Z"
          mask="url(#path-7-inside-2_2794_24130)"
        />
      </clipPath>
      <clipPath
        id="bgblur_2_2794_24130_clip_path"
        transform="translate(-15 8.00002)"
      >
        <path d="M23 7.99998C23 3.58171 26.5817 -1.52588e-05 31 -1.52588e-05H50C54.4183 -1.52588e-05 58 3.58171 58 7.99998V27C58 31.4183 54.4183 35 50 35H31C26.5817 35 23 31.4183 23 27V7.99998Z" />
      </clipPath>
      <clipPath id="paint12_angular_2794_24130_clip_path">
        <path
          d="M31 -1.52588e-05V0.499985H50V-1.52588e-05V-0.500015H31V-1.52588e-05ZM58 7.99998H57.5V27H58H58.5V7.99998H58ZM50 35V34.5H31V35V35.5H50V35ZM23 27H23.5V7.99998H23H22.5V27H23ZM31 35V34.5C26.8579 34.5 23.5 31.1421 23.5 27H23H22.5C22.5 31.6944 26.3056 35.5 31 35.5V35ZM58 27H57.5C57.5 31.1421 54.1421 34.5 50 34.5V35V35.5C54.6944 35.5 58.5 31.6944 58.5 27H58ZM50 -1.52588e-05V0.499985C54.1421 0.499985 57.5 3.85785 57.5 7.99998H58H58.5C58.5 3.30556 54.6944 -0.500015 50 -0.500015V-1.52588e-05ZM31 -1.52588e-05V-0.500015C26.3056 -0.500015 22.5 3.30556 22.5 7.99998H23H23.5C23.5 3.85785 26.8579 0.499985 31 0.499985V-1.52588e-05Z"
          mask="url(#path-12-inside-3_2794_24130)"
        />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2794_24130"
        x1="40.5"
        x2="40.5"
        y1="10"
        y2="70"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#4691F4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2794_24130"
        x1="18"
        x2="18"
        y1="45"
        y2="80"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2794_24130"
        x1="54.5"
        x2="35.7742"
        y1="53.5"
        y2="76.9133"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_2794_24130"
        x1="29.5"
        x2="12.575"
        y1="62.5"
        y2="72.64"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_2794_24130"
        x1="29.5"
        x2="12.575"
        y1="71.5"
        y2="81.64"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_2794_24130"
        x1="63"
        x2="63"
        y1="45"
        y2="80"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_2794_24130"
        x1="99.5"
        x2="80.7742"
        y1="53.5"
        y2="76.9133"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint9_linear_2794_24130"
        x1="74.5"
        x2="57.575"
        y1="62.5"
        y2="72.64"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint10_linear_2794_24130"
        x1="74.5"
        x2="57.575"
        y1="71.5"
        y2="81.64"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint11_linear_2794_24130"
        x1="40.5"
        x2="40.5"
        y1="-1.52588e-05"
        y2="35"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint13_linear_2794_24130"
        x1="77"
        x2="58.2742"
        y1="8.49999"
        y2="31.9133"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint14_linear_2794_24130"
        x1="52"
        x2="35.075"
        y1="17.5"
        y2="27.64"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint15_linear_2794_24130"
        x1="52"
        x2="35.075"
        y1="26.5"
        y2="36.64"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </svg>
)
